import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Helmet } from "react-helmet";
import PublicRoute from "./routes/PublicRoute";
import PrivateRoute from "./routes/PrivateRoute";
import Login from "./pages/login";
import Home from "./pages/home";
import Layout from "./layout";
import Tournament from "./pages/tournament";
import Push from "./pages/push";
import PushDetail from "./pages/push/component/pushDetail/pushDetail";
import PushSend from "./pages/push/component/pushSend/pushSend";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { dialogState } from "./recoil/dialog.atom";
import Dialog from "./component/Dialog";
import styled, { keyframes } from "styled-components";
import { loadingState } from "./recoil/loading.atom";
import Reservation from "./pages/reservation";
import UserTimer2 from "./pages/user-timer/timer2/timer2";
import Store from "./pages/store";
import UserWeb from "./pages/user-web";
import Marketing from "./pages/marketing";
import ManageMent from "./pages/management";
import { DialogOverlay } from "./component/InputDialog/style";
import Event from "./pages/event";
import UserTimer4 from "./pages/user-timer/timer4/timer4";
import UserTimer5 from "./pages/user-timer/timer5/timer5";
import Solution from "./pages/solution";
import Member from "./pages/member";
import { setLoadingStateSetter } from "./utils/network";
import { useEffect } from "react";
import UserVerticalTimer4 from "./pages/user-timer/timer4/timer4_vertical";
import UserVerticalTimer5 from "./pages/user-timer/timer5/timer5_vertical";
import UserVerticalTimer3 from "./pages/user-timer/timer3/timer3_vertical";
import UserVerticalTimer2 from "./pages/user-timer/timer2/timer2_vertical";
import UserVerticalTimer1 from "./pages/user-timer/timer1/timer1_vertical";
import RankingBoard from "./pages/ranking-board";
import PubList from "./pages/pub-list";
import TimerController from "./pages/timer-controller";
import { customDialogState } from "./recoil/custom-dialog.atom";
import CustomDialog from "./component/CustomDialog";
import { ControllerProvider } from "./pages/timer-controller/hooks/controller-context";
import { ParticipantProvider } from "./pages/timer-controller/components/sit-in/hooks/participant-context";
import AppOrder from "./pages/solution/components/app-order";
import PosterMaker from "./pages/poster-maker";
import DailySettlement from "./pages/daily-settlement";
import { DailySettlementProvider } from "./pages/daily-settlement/hooks/daily-settlement-context";
import { WideState } from "./recoil/wide";
import MonthSettlement from "./pages/month-settlement";
import { MonthSettlementProvider } from "./pages/month-settlement/hooks/month-settlement-context";
import UserTimer3 from "./pages/user-timer/timer3/timer3";
import UserTimer1 from "./pages/user-timer/timer1/timer1";
import { checkIsMobile } from "./utils/device";
import TournamentTicketStore from "./pages/tournament-ticket-store";
import TournamentTicketRequest from "./pages/tournament-ticket-request";
import EventMission from "./pages/event-mission";
import EventBingo from "./pages/event-bingo";
import EventMemberProgress from "./pages/event-member-progress";
import EventLogs from "./pages/event-logs";
import OwnerManagement from "./pages/owner";

const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); // 반투명 검정색
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const Spinner = styled.div`
  border: 4px solid rgba(255, 255, 255, 0.3); // 회색 테두리
  border-radius: 50%;
  border-top-color: #fff; // 흰색 부분
  width: 50px;
  height: 50px;
  animation: ${rotate} 1s linear infinite;
`;
function App() {
  const dialog = useRecoilValue(dialogState);
  const customDialog = useRecoilValue(customDialogState);
  const isLoading = useRecoilValue(loadingState);
  const setLoading = useSetRecoilState(loadingState);
  const [isWide, setIsWide] = useRecoilState(WideState);
  useEffect(() => {
    const handleResize = () => {
      // 700px 이하이거나 모바일 기기(갤럭시 폴드 등)인 경우 isWide를 false로 설정 (모바일 뷰)
      setIsWide(!checkIsMobile());
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [setIsWide]);

  // 리코일 못 쓰니까 함수 전달용
  useEffect(() => {
    setLoadingStateSetter(setLoading);
  }, [setLoading]);

  return (
    <BrowserRouter>
      <Helmet>
        <title>
          {process.env.REACT_APP_ENV === "production"
            ? "러너러너 펍 관리"
            : "[TEST]펍 관리"}
        </title>
      </Helmet>
      {isLoading && (
        <LoadingOverlay>
          <Spinner />
        </LoadingOverlay>
      )}
      <Routes>
        <Route path="/login" element={<PublicRoute />}>
          <Route path="/login" element={<Login />} />
          <Route path="/login/pub-list" element={<PubList />} />
        </Route>

        <Route path="/" element={<PrivateRoute />}>
          <Route path="/ranking-board" element={<RankingBoard />} />
          <Route
            path="/timer-config/:id"
            element={
              <ControllerProvider>
                <ParticipantProvider>
                  <TimerController />
                </ParticipantProvider>
              </ControllerProvider>
            }
          />
          <Route path="/timer1/:id" element={<UserTimer1 />} />
          <Route path="/vertical/timer1/:id" element={<UserVerticalTimer1 />} />
          <Route path="/timer2/:id" element={<UserTimer2 />} />
          <Route path="/vertical/timer2/:id" element={<UserVerticalTimer2 />} />
          <Route path="/timer3/:id" element={<UserTimer3 />} />
          <Route path="/vertical/timer3/:id" element={<UserVerticalTimer3 />} />
          <Route path="/timer4/:id" element={<UserTimer4 />} />
          <Route path="/vertical/timer4/:id" element={<UserVerticalTimer4 />} />
          <Route path="/timer5/:id" element={<UserTimer5 />} />
          <Route path="/vertical/timer5/:id" element={<UserVerticalTimer5 />} />
          <Route path="/order-management" element={<AppOrder />} />
          <Route path="/" element={<Layout />}>
            {isWide ? (
              <Route path="/" element={<Home />} />
            ) : (
              <Route path="/" element={<Tournament />} />
            )}
            <Route path="/tournament/*" element={<Tournament />} />
            <Route path="/push/*" element={<Push />} />
            <Route path="/pushDetail/:id" element={<PushDetail />} />
            <Route path="/PushSend/" element={<PushSend />} />
            <Route path="/PushSend/:id" element={<PushSend />} />
            <Route path="/solution" element={<Solution />} />
            <Route path="/Member" element={<Member />} />
            <Route path="/event" element={<Event />} />
            <Route path="/reservation" element={<Reservation />} />
            <Route path="/store" element={<Store />} />
            <Route path="/user-web" element={<UserWeb />} />
            <Route path="/marketing" element={<Marketing />} />
            <Route path="/management" element={<ManageMent />} />
            <Route path="/ticket-store" element={<TournamentTicketStore />} />
            <Route
              path="/ticket-request"
              element={<TournamentTicketRequest />}
            />
            <Route path="/ticket-member" element={<Navigate to="/ticket-store" replace />} />
            <Route path="/event/mission" element={<EventMission />} />
            <Route path="/event/bingo" element={<EventBingo />} />
            <Route
              path="/event/member-progress"
              element={<EventMemberProgress />}
            />
            <Route path="/event/logs" element={<EventLogs />} />
            <Route path="/owners" element={<OwnerManagement />} />
            {process.env.REACT_APP_ENV !== "production" && (
              <>
                <Route
                  path="/daily-settlement"
                  element={
                    <DailySettlementProvider>
                      <DailySettlement />
                    </DailySettlementProvider>
                  }
                />
                <Route
                  path="/month-settlement"
                  element={
                    <MonthSettlementProvider>
                      <MonthSettlement />
                    </MonthSettlementProvider>
                  }
                />
              </>
            )}
            <Route path="/poster-maker" element={<PosterMaker />} />
          </Route>
        </Route>
      </Routes>
      {customDialog && <CustomDialog />}
      {dialog && <Dialog />}
      {(dialog || customDialog) && <DialogOverlay />}
    </BrowserRouter>
  );
}

export default App;
